import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';

import CustomPasswordField from '../CustomPasswordField';

/*
 * Controlled Input
 * Needs to be wrapped in a <FormProvider {...methods}> that receives all methods from useForm (react-hook-form)
 * name needs to match field used in useForm defaultValues
 */

const ControlledPasswordField = ({ name, label, showSuccessAdornment, showSuccess }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value }, fieldState }) => {
        const isSuccess = showSuccess && fieldState.isTouched && !fieldState.error && !!value?.length;
        return (
          <CustomPasswordField
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            label={label}
            type="password"
            error={fieldState.error?.message}
            success={isSuccess}
            showSuccessAdornment={showSuccessAdornment}
          />
        );
      }}
    />
  );
};

ControlledPasswordField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  showSuccessAdornment: PropTypes.bool,
  showSuccess: PropTypes.bool,
};

export default ControlledPasswordField;
